import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ReinforcementLearningIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 40 40" fill="none" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.333"
        d="M9.919 33.34V23.336m0-6.67V6.663m10.08 26.678V21.667m0-6.669V6.662m10.082 26.677V26.67m0-6.669V6.661M6.66 23.337h6.516m3.564-8.338h6.517m3.564 11.672h6.517"
      />
    </Icon>
  );
}
